import { InputNumber, Radio, Form } from "antd";
import './index.less';
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export default function SlipForm({ form, placeholder }: any) {
  const inputRef = useRef<any>(null);
  const fees = [51, 0.3, 0.5, 1, 3];
  const formFee = form.getFieldValue('slip');
  const [fee, setFee] = useState(fees.includes(formFee) ? formFee : -1);
  const { t } = useTranslation();

  const options = [{
    label: t('batchSwap.auto'),
    value: 51
  }, {
    label: '0.3%',
    value: 0.3
  }, {
    label: '0.5%',
    value: 0.5
  }, {
    label: '1.0%',
    value: 1
  }, {
    label: '3.0%',
    value: 3
  }];

  // useEffect(() => {
  //   form.setFieldsValue({ slip: fee });
  // }, [fee, form]);

  function renderOption() {
    return (
      <>
        {
          options.map((item: any, index: any) => {
            return (
              <Radio.Button value={item.value} key={index}>{t(item.label)}</Radio.Button>
            );
          })
        }
      </>
    );
  }

  function Item(props: any) {
    return (
      <Radio.Group
        className="sl-radio-btn-group"
        {...props}
        onChange={e => {
          setFee(e.target.value);
          form.setFieldsValue({slip: e.target.value, slipInput: '' });
        }}
        buttonStyle="solid"
      >
        {renderOption()}
      </Radio.Group>
    );
  }

  function ItemInput(props: any) {
    return (
      <div className="input-unit">
        <InputNumber
          ref={inputRef}
          min={0}
          max={100}
          {...props}
          onFocus={() => {
            setFee(-1);
            form.setFieldsValue({ slip: -1 });
            setTimeout(()=>{
              inputRef.current.focus();
            },100);
          }}
          className={fee === -1 ? "jito-fee-input ant-input-number-selected" : "jito-fee-input"}
          // defaultValue={3.0}
          controls={false}
          suffix="%"
          onBlur={(e)=>{
            let value = e.target.value;
            console.log('>>',value, typeof value);
            if(!/^(100(\.0{1,2})?|(\d{1,2}(\.\d{1,2})?))$/.test(value)){
              setFee(options[0].value);
              form.setFieldsValue({ slip: options[0].value,slipInput: "" });
            }
          }}
        />
        {/* <span className="unit">%</span> */}
      </div>
    );
  }

  // useEffect(() => {
  //   form.setFieldsValue({ slip: fee });
  // }, [fee, form]);

  useEffect(() => {
    if(formFee !== -1){
      setFee(formFee);
    }
  }, [formFee]);

  return (
    <div className="slip-form">
      <div className="jito-option-title">
        <span>{t("batchSwap.slipSetting")}</span>
      </div>
      <Form.Item
        className="mix-form-item"
        shouldUpdate={(prevValues, currentValues) => prevValues.slip !== currentValues.slip}
      >
        {() => (
          <div className="jito-option-body">
            {/* <Form.Item
              label={null}
              name="slip"
            >
              <Item />
            </Form.Item>
            <Form.Item
              label={null}
              name="slipInput"
            >
              <ItemInput />
            </Form.Item> */}
            <div className="slip-radio">
              <Form.Item
                label={null}
                name="slip"
              >
                <Item />
              </Form.Item>
            </div>
            <div className="slip-input">
              <Form.Item
                label={null}
                name="slipInput"
              >
                {/* <ItemInput placeholder={placeholder}/> */}
                <InputNumber
                  ref={inputRef}
                  min={0}
                  max={100}
                  // {...props}
                  placeholder={placeholder || t("btn.Custom")}
                  onFocus={() => {
                    setFee(-1);
                    form.setFieldsValue({ slip: -1 });
                  }}
                  className={fee === -1 ? "jito-fee-input ant-input-number-selected" : "jito-fee-input"}
                  // defaultValue={3.0}
                  controls={false}
                  suffix="%"
                  onBlur={(e)=>{
                    setTimeout(()=>{
                      let value = e.target.value;
                      // console.log('>>',value, typeof value,/^(100(\.0{1,2})?|(\d{1,2}(\.\d{1,2})?))$/.test(value));
                      if(!/^(100(\.0{1,2})?|(\d{1,2}(\.\d{1,2})?))$/.test(value)){
                        setFee(options[0].value);
                        form.setFieldsValue({ slip: options[0].value,slipInput: "" });
                      }
                    },0);
                  }}
                />
              </Form.Item>
            </div>
          </div>
        )}
      </Form.Item>
    </div>
  );
}
